export const newsList = [
  {
    id: "news-001",
    title: "《漫长的季节》口碑持续走高，东北叙事为何再度打动观众",
    date: "2023-06-02",
    category: "深度解析",
    excerpt:
      "从桦林的雪到时代的褶皱，这部剧用十二集的篇幅讲透了一代人的青春与遗憾，也再次证明慢工出细活的创作逻辑依然有效。",
    relatedId: "chang-ye-de-ji-jie",
  },
  {
    id: "news-002",
    title: "《狂飙》余温未散：国产犯罪剧的类型突破与人物弧光",
    date: "2023-03-15",
    category: "行业观察",
    excerpt:
      "从鱼贩到枭雄，高启强的人物弧线让整部剧立体起来。本文梳理近年国产犯罪剧在群像塑造上的进阶路径。",
    relatedId: "kuang-biao",
  },
  {
    id: "news-003",
    title: "国产科幻剧的里程碑：《三体》如何把文本想象变成影像",
    date: "2023-02-20",
    category: "幕后揭秘",
    excerpt:
      "从红岸基地到古筝行动，剧组用克制的美学还原了原著的硬核气质。美术与特效团队分享了背后的取舍。",
    relatedId: "san-ti",
  },
  {
    id: "news-004",
    title: "《流浪地球 2》重映热度不减，工业级科幻再成话题中心",
    date: "2023-04-10",
    category: "影讯快报",
    excerpt:
      "前传格局下的宏大叙事与细腻情感并重，影片的太空电梯段落被影迷反复拆解讨论，视觉工业水准再上台阶。",
    relatedId: "liu-lang-di-qiu-2",
  },
  {
    id: "news-005",
    title: "《奥本海默》横扫颁奖季：一部关于良知与责任的传记片",
    date: "2024-01-08",
    category: "奖项追踪",
    excerpt:
      "诺兰用三个小时的密集叙事，把科学家的荣耀与煎熬摆在观众面前，影片的剪辑与配乐成为讨论焦点。",
    relatedId: "o-ben-hai-mo",
  },
  {
    id: "news-006",
    title: "《沙丘 2》登陆院线：沙漠美学的极致体验如何炼成",
    date: "2024-03-12",
    category: "幕后揭秘",
    excerpt:
      "从实景沙漠到极致音效，维伦纽瓦延续了对沉浸感的执念，影片被不少影迷称为“必须进影院”的作品。",
    relatedId: "sha-qiu-2",
  },
  {
    id: "news-007",
    title: "经典重看：《星际穿越》十年之后，依旧是最浪漫的科幻",
    date: "2024-11-06",
    category: "经典重温",
    excerpt:
      "当父女之爱穿越时间与空间，科幻不再只是冰冷的技术。十年过去，影片关于时间与情感的表达依然动人。",
    relatedId: "xing-ji-chuan-yue",
  },
  {
    id: "news-008",
    title: "韩剧现象再观察：《请回答 1988》为何常看常新",
    date: "2024-05-18",
    category: "深度解析",
    excerpt:
      "没有反派、没有爽点，双门洞的日常却能反复治愈观众。本文聊聊生活流叙事的长久魅力。",
    relatedId: "qing-hui-da-1988",
  },
  {
    id: "news-009",
    title: "《封神第一部》神话工业化的第一步，做对了什么",
    date: "2023-08-01",
    category: "行业观察",
    excerpt:
      "从演员训练营到三部连拍，影片的工业化探索为华语神话史诗提供了新的样本，也留下不少值得讨论的课题。",
    relatedId: "feng-shen-di-yi-bu",
  },
  {
    id: "news-010",
    title: "暑期档前瞻：多部重磅剧集定档，悬疑与年代题材正面交锋",
    date: "2024-06-25",
    category: "影讯快报",
    excerpt:
      "随着多部新剧陆续官宣，暑期档的竞争格局逐渐清晰。我们盘点了最值得期待的几部作品与看点。",
    relatedId: "yin-mi-de-jiao-luo",
  },
  {
    id: "news-011",
    title: "从《觉醒年代》看主旋律剧集的年轻化表达",
    date: "2021-06-30",
    category: "深度解析",
    excerpt:
      "鲜活的人物、生活化的细节，让历史题材走进年轻人的讨论场。本文拆解其叙事策略与情感落点。",
    relatedId: "jue-xing-nian-dai",
  },
  {
    id: "news-012",
    title: "奇幻史诗的十年：《权力的游戏》留给后来者的启示",
    date: "2024-04-22",
    category: "经典重温",
    excerpt:
      "宏大的世界观与注定争议的结局，让这部剧始终处在讨论中心。它的成功与遗憾都值得被认真复盘。",
    relatedId: "quan-li-de-you-xi",
  },
];